import dashboard from "./dashboard";
import ecompliancehome from "./ecompliancehome";
import slbchome_2 from "./slbchome_2";
import hrms_home from "./hrms_home";
import dcollector from "./dcollector";
import dashboard1 from "./dashboard1";
import dashboard2 from "./dashboard2";
import dashboard3 from "./dashboard3";
import dashboard4 from "./dashboard4";
import dashboard5 from "./dashboard5";
import dashboard6 from "./dashboard6";





export default {
  dashboard, ecompliancehome, slbchome_2, hrms_home, dcollector, dashboard1, dashboard2, dashboard3, dashboard4, dashboard5, dashboard6
};